// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"413969df","133":"2db33fc7","139":"87132035","493":"da7606b1","746":"2860fdbc","758":"37b7803d","780":"129fa0d9","852":"2e301ee7","971":"6e5b394f"}[chunkId] + ".chunk.js";
};